const APP = 'dataBinding';
const TYPE = 'viewerStatusForEditor';

export const onViewerStatusMessage = ({
  handle,
  global,
}: {
  handle: (viewerStatusMessage: string) => void;
  global: any;
}) => {
  const listener = (event: any) => {
    if (event?.data?.app === APP && event?.data?.type === TYPE) {
      handle(event.data.message);
    }
  };
  global.addEventListener('message', listener);
  return () => {
    global.removeEventListener('message', listener);
  };
};
